"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.array.includes.js");

var _react = _interopRequireDefault(require("react"));

var _mobileDetect = _interopRequireDefault(require("mobile-detect/mobile-detect"));

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../../lib/utils");

var _fetchInbox = require("@evdy/web-redux/dist/actions/webAnnouncement/fetchInbox");

var _setMobileOS = require("@evdy/web-redux/dist/actions/setMobileOS");

var _HomeLinks = _interopRequireDefault(require("./HomeLinks"));

var _SocialsFooter = _interopRequireDefault(require("./SocialsFooter"));

var _SecondaryLinks = _interopRequireDefault(require("./SecondaryLinks"));

var _UserSection = _interopRequireDefault(require("./UserSection"));

var _DashSections = _interopRequireDefault(require("./DashSections"));

require("../../../../sass/components/shared/elements/MobileMenu.css");

var _mobileMenuCloseIcon = _interopRequireDefault(require("../../../../images/shared/icons/mobile-menu-close-icon.svg"));

var _searchIconBlack = _interopRequireDefault(require("../../../../images/shared/icons/search-icon-black.svg"));

var _dec, _class, _class2, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var blueLogo = 'https://everdays-site.s3.amazonaws.com/shared/logos/everdays-gradient-logo.svg';
var string = _propTypes.default.string,
    number = _propTypes.default.number,
    func = _propTypes.default.func,
    object = _propTypes.default.object,
    array = _propTypes.default.array;
var staticPageNames = ['home', 'families', 'partners', 'careers', 'funeral-homes', 'funeral-director', 'funeral-program', 'how-to-plan', 'inspiration', 'online-obituaries', 'pet-cemetery', 'press', 'why', 'terms', 'privacy'];
var MobileMenu = (_dec = (0, _reactRedux.connect)(function (_ref) {
  var dash = _ref.dash,
      fetchInbox = _ref.fetchInbox,
      chat = _ref.chat,
      mobileOS = _ref.mobileOS;
  return {
    user: dash.user.data,
    inbox: fetchInbox.inbox.data,
    unreadCount: chat.unreadCount,
    mobileOS: mobileOS
  };
}, null, null, {
  forwardRef: true
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(MobileMenu, _React$Component);

  var _super = _createSuper(MobileMenu);

  function MobileMenu(props) {
    var _this;

    _classCallCheck(this, MobileMenu);

    _this = _super.call(this, props);
    _this.viewMoreIncrement = 5;
    _this.setMobileMenu = _this.setMobileMenu.bind(_assertThisInitialized(_this));
    _this.handleAuthAction = _this.handleAuthAction.bind(_assertThisInitialized(_this));
    _this.handleViewMore = _this.handleViewMore.bind(_assertThisInitialized(_this));
    _this.toggleAnncList = _this.toggleAnncList.bind(_assertThisInitialized(_this));
    _this.renderPrincipalButton = _this.renderPrincipalButton.bind(_assertThisInitialized(_this));
    _this.state = {
      isMobileMenuOpen: false,
      isAnncListOpen: false,
      anncDisplayCount: 0
    };
    var dispatch = props.dispatch,
        user = props.user;
    if (user) dispatch((0, _fetchInbox.fetchInboxAction)());
    return _this;
  }

  _createClass(MobileMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!global.window) return;
      var md = new _mobileDetect.default(window.navigator.userAgent);
      this.props.dispatch((0, _setMobileOS.recordMobileOS)(md.os()));
      this.props.dispatch((0, _setMobileOS.recordMobileUA)(md.userAgent()));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          dispatch = _this$props.dispatch,
          user = _this$props.user;
      var prevUser = prevProps.user;

      if (user && !prevUser) {
        dispatch((0, _fetchInbox.fetchInboxAction)());
      }
    }
  }, {
    key: "renderPrincipalButton",
    value: function renderPrincipalButton() {
      var _this2 = this;

      var _this$props2 = this.props,
          currentPage = _this$props2.currentPage,
          handlePrincipalButton = _this$props2.handlePrincipalButton;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "principal-button-container"
      }, currentPage === 'web-annc' ? /*#__PURE__*/_react.default.createElement("a", {
        href: "https://app.everdays.com/",
        target: "_blank",
        rel: "noopener noreferrer",
        className: "download-button",
        onClick: function onClick() {
          (0, _utils.googleAnalytics)("download_app")();

          _this2.setState({
            isMobileMenuOpen: false
          });
        }
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "mobile-menu-principal-button"
      }, "Open In App")) : /*#__PURE__*/_react.default.createElement("button", {
        className: "mobile-menu-principal-button",
        onClick: function onClick() {
          handlePrincipalButton();

          _this2.setState({
            isMobileMenuOpen: false
          });
        }
      }, "Create Announcement"));
    }
  }, {
    key: "setMobileMenu",
    value: function setMobileMenu(isMobileMenuOpen) {
      var _this3 = this;

      return function () {
        return _this3.setState({
          isMobileMenuOpen: isMobileMenuOpen
        });
      };
    }
  }, {
    key: "handleAuthAction",
    value: function handleAuthAction(type) {
      var _this$props3 = this.props,
          currentPage = _this$props3.currentPage,
          handleAuthModal = _this$props3.handleAuthModal;

      if (currentPage === 'partners') {
        var dashURL = type === 'signup' ? 'https://everdays.com/dash/signup' : 'https://dash.everdays.com';
        window.location.href = dashURL;
        return;
      }

      handleAuthModal('', type);
    }
  }, {
    key: "handleViewMore",
    value: function handleViewMore() {
      var anncDisplayCount = this.state.anncDisplayCount;
      this.setState({
        anncDisplayCount: anncDisplayCount + this.viewMoreIncrement
      });
    }
  }, {
    key: "toggleAnncList",
    value: function toggleAnncList() {
      this.setState({
        isAnncListOpen: !this.state.isAnncListOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props4 = this.props,
          user = _this$props4.user,
          currentPage = _this$props4.currentPage,
          mobileOS = _this$props4.mobileOS,
          unreadCount = _this$props4.unreadCount,
          handleSignOut = _this$props4.handleSignOut,
          inbox = _this$props4.inbox,
          openSwitchCompanyModal = _this$props4.openSwitchCompanyModal,
          openSearchModal = _this$props4.openSearchModal,
          _this$props4$dashLink = _this$props4.dashLinks,
          dashLinks = _this$props4$dashLink === void 0 ? [] : _this$props4$dashLink,
          showAuthLinks = _this$props4.showAuthLinks;
      var _this$state = this.state,
          isAnncListOpen = _this$state.isAnncListOpen,
          anncDisplayCount = _this$state.anncDisplayCount;
      var mobileMenuClasses = (0, _classnames.default)({
        'new-mobile-menu': true,
        open: this.state.isMobileMenuOpen
      });
      var anncCount = 0;

      if (inbox) {
        anncCount = inbox.length;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: mobileMenuClasses
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "mobile-menu-header"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _mobileMenuCloseIcon.default,
        alt: "close menu icon",
        onClick: function onClick() {
          _this4.setMobileMenu(false)();

          (0, _utils.googleAnalytics)("".concat(currentPage, "_mobile-menu_close"))();
        }
      }), /*#__PURE__*/_react.default.createElement("a", {
        className: "mobile-menu-logo",
        href: "/",
        onClick: (0, _utils.googleAnalytics)('header_mobile_home', 'link_press')
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: blueLogo,
        alt: "logo"
      }))), !staticPageNames.includes(currentPage) && this.renderPrincipalButton(), currentPage === 'dash' && /*#__PURE__*/_react.default.createElement(_DashSections.default, {
        dashLinks: dashLinks,
        currentDashTab: this.props.currentDashTab,
        setMobileMenu: this.setMobileMenu
      }), (currentPage === 'home' || currentPage === 'web-annc') && /*#__PURE__*/_react.default.createElement("button", {
        className: "mobile-menu-searchButton",
        onClick: function onClick() {
          openSearchModal();
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _searchIconBlack.default,
        alt: "search icon"
      }), /*#__PURE__*/_react.default.createElement("span", null, "Search Everdays")), user && /*#__PURE__*/_react.default.createElement(_UserSection.default, {
        isAnncListOpen: isAnncListOpen,
        anncCount: anncCount,
        anncDisplayCount: anncDisplayCount,
        handleViewMore: this.handleViewMore,
        viewMoreIncrement: this.viewMoreIncrement,
        toggleAnncList: this.toggleAnncList,
        user: user,
        inbox: inbox,
        currentPage: currentPage
      }), staticPageNames.includes(currentPage) && /*#__PURE__*/_react.default.createElement(_HomeLinks.default, {
        currentPage: currentPage,
        handleAuthAction: this.handleAuthAction
      }), /*#__PURE__*/_react.default.createElement(_SecondaryLinks.default, {
        handleAuthAction: this.handleAuthAction,
        setMobileMenu: this.setMobileMenu,
        user: user,
        openSwitchCompanyModal: openSwitchCompanyModal,
        handleSignOut: handleSignOut,
        currentPage: currentPage,
        unreadCount: unreadCount,
        showAuthLinks: showAuthLinks
      }), currentPage !== 'web-annc' && /*#__PURE__*/_react.default.createElement(_SocialsFooter.default, {
        currentPage: currentPage,
        mobileOS: mobileOS
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var inbox = props.inbox;

      if (!state.anncDisplayCount && inbox && inbox.length) {
        var newDisplayCount = Math.min(inbox.length, 3);
        return {
          anncDisplayCount: newDisplayCount
        };
      } else {
        return null;
      }
    }
  }]);

  return MobileMenu;
}(_react.default.Component), _class2.propTypes = {
  user: object,
  handleSignOut: func.isRequired,
  currentPage: string.isRequired,
  inbox: array,
  unreadCount: number,
  dispatch: func,
  handlePrincipalButton: func,
  handleAuthModal: func,
  mobileOS: object,
  currentDashTab: string
}, _class2.defaultProps = {
  inbox: [],
  unreadCount: 0,
  mobileOS: {},
  currentDashTab: '',
  openSearchModal: function openSearchModal() {}
}, _temp)) || _class);
exports.default = MobileMenu;